import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Loader, Comment, Form, Header, Label, Icon, Divider
} from 'semantic-ui-react'
import { Duration } from 'luxon'
import { path } from 'ramda'
import CommentActions from 'Redux/CommentRedux'
import SearchComments from 'Components/Comments/SearchComments'
import ConfirmPopup from 'Components/ConfirmPopup'
import Avatar from 'Components/Avatar'

import styles from './ListStyles.js'

class CommentsList extends Component {
  static propTypes = {
    videoId: PropTypes.number.isRequired
  }

  constructor () {
    super()
    this.state = {
      showReplyBoxId: null,
      replyText: ''
    }
  }

  componentDidMount () {
    this.fetchComments()
  }

  componentDidUpdate (prevProps) {
    if (this.props.videoId !== prevProps.videoId) {
      this.fetchComments()
    }
  }

  fetchComments = () => {
    this.props.commentsListRequest(this.props.videoId)
  }

  setReplyBoxId = (commentId) => () => {
    // if clicked on different comment
    if (commentId !== this.state.showReplyBoxId) {
      this.setState({ replyText: '' })
    }
    this.setState({ showReplyBoxId: commentId })
  }

  onAddReply = () => {
    if (this.state.replyText.trim()) {
      this.props.commentsCreateRequest({
        text: this.state.replyText,
        time: this.props.time,
        video_id: this.props.videoId,
        parent_id: this.state.showReplyBoxId
      })
      this.setState({ replyText: '' })
      this.setReplyBoxId({ showReplyBoxId: '' })()
    }
  }

  setReplyText = (_, { value }) => {
    this.setState({ replyText: value })
  }

  renderReplyBox (comment) {
    if (this.state.showReplyBoxId !== comment.id) return null
    return (
      <Form className={styles.replyInputForm}>
        <Form.Input
          autoFocus
          fluid
          placeholder='Write a reply...'
          onChange={this.setReplyText}
          value={this.state.replyText}
        />
        <Form.Button
          className={styles.replyBtnForm}
          onClick={this.onAddReply}
        />
      </Form>
    )
  }

  renderReplyComments = (replies) => {
    return replies.map(reply => {
      return (
        <Comment key={reply.id}>
          <div className='avatar'>
            <Avatar
              name={reply.name}
              radius={30}
            />
          </div>
          <Comment.Content>
            <Comment.Author as='a'>
              {reply.author}
            </Comment.Author>
            <Comment.Text>{reply.text}</Comment.Text>
            <Comment.Actions>
              <div className={styles.replyRow}>
                <div className={styles.timeAgo}>{reply.timeAgo} ago</div>
                { this.getDeleteOption(reply) }
              </div>
            </Comment.Actions>
          </Comment.Content>
        </Comment>
      )
    })
  }

  setCurrentComment = (comment) => (e) => {
    this.props.commentsSetCurrent(comment)
  }

  onDelete = (commentId) => () => {
    this.props.commentsDeleteRequest(commentId, this.props.videoId)
  }

  getDeleteOption = (comment) => {
    if (comment.email === this.props.username &&
        (!comment.children || !comment.children.length )
      ) {
      return (
        <ConfirmPopup
          trigger={
            <Comment.Action>Delete</Comment.Action>
          }
          position='bottom right'
          onConfirm={this.onDelete(comment.id)}
        />
      )
    }

    return null
  }

  render () {
    return (
      <Comment.Group size='small'>
        <Header as='h3' className={styles.header}>
          Comments
        </Header>
        <Divider></Divider>
        <SearchComments
          videoId={this.props.videoId}
        />

        <Loader active={this.props.fetching}/>

        <div className={styles.commentsWrap}>
          {this.props.comments.map(comment => {
            const pointsLength = path(['points', 'data', 'length'], comment)
            const commentClass = comment.id === this.props.currentComment.id
              ? styles.singleCommentSelected : styles.singleComment
            return (
              <Comment
                className={commentClass}
                key={comment.id}
                onClick={this.setCurrentComment(comment)}>
                <div className='avatar'>
                  <Avatar
                    name={comment.author}
                    radius={30}
                  />
                </div>
                <Comment.Content>
                  <Comment.Author as='a'>
                    {comment.author}
                  </Comment.Author>
                  <Comment.Metadata>
                    <div>
                      <Label size='tiny'>
                        {Duration.fromMillis(comment.time).toFormat('MM:SS')}
                      </Label>
                      { pointsLength > 0 &&
                        <Label size='tiny' color='yellow'>
                          <Icon name='paint brush' fitted/>
                        </Label>
                      }
                    </div>
                  </Comment.Metadata>
                  <Comment.Text>{comment.text}</Comment.Text>
                  <Comment.Actions>
                    <div className={styles.replyRow}>
                      <div className={styles.timeAgo}>{comment.timeAgo} ago</div>
                      <Comment.Action onClick={this.setReplyBoxId(comment.id)}>
                          Reply
                      </Comment.Action>
                      { this.getDeleteOption(comment) }
                    </div>
                    { this.renderReplyBox(comment) }
                  </Comment.Actions>
                </Comment.Content>
                {comment.children.length > 0 &&
                  <Comment.Group size='small'>
                    {this.renderReplyComments(comment.children)}
                  </Comment.Group>
                }
              </Comment>
            )
          })}
        </div>
      </Comment.Group>
    )
  }
}

const mapStateToProps = (state) => ({
  comments: state.comments.listData,
  fetching: state.comments.listFetching,
  currentComment: state.comments.currentComment,
  username: state.auth.userData.uid
})

const mapDispatchToProps = (dispatch) => ({
  commentsListRequest: (videoId) =>
    dispatch(CommentActions.commentsListRequest(videoId)),
  commentsCreateRequest: (params) =>
    dispatch(CommentActions.commentsCreateRequest(params)),
  commentsDeleteRequest: (commentId, videoId) =>
    dispatch(CommentActions.commentsDeleteRequest(commentId, videoId)),
  commentsSetCurrent: (comment) =>
    dispatch(CommentActions.commentsSetCurrent(comment))
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentsList)



// WEBPACK FOOTER //
// ./src/Components/Comments/List.js